// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PPsMap {\n  min-width: 30vw;\n  min-height: 60vh;\n}\n\n.leaflet-container.crosshair-cursor-enabled {\n  cursor: crosshair;\n}\n\n.PPsGrid {\n  min-height: 45vh;\n  height: 60vh;\n}\n\n.FocusedMarkerTooltip {\n  font-weight: bold !important;\n}", ""]);
// Exports
module.exports = exports;
